// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__Mb6Bg","content":"GlobalSearch_content__3HC91"};